import React from 'react';
import ProductOffer from 'model/ProductOffer';
import { ProducerInfoContainer, ProducerItem } from './ProducerInfo.styled';
import { 
  ProducerLabel, 
  ProducerText 
} from '../../atoms';

export interface ProducerInfoProps {
  product: ProductOffer;
}

export function ProducerInfo({ product }: ProducerInfoProps) {
  if (!product.producerName) return null;
  
  return (
    <ProducerInfoContainer  className='producer-info'>
      <ProducerItem className='producer-info-item'>
        <ProducerLabel className="producer-label">Produtor:</ProducerLabel>
        <ProducerText>{product.siteName}</ProducerText>
      </ProducerItem>
    </ProducerInfoContainer>
  );
}
